import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // Cache commonly used DOM elements
        this.productsNavTypes = this.$('toggle');
        this.productsNavItems = this.el.querySelectorAll('[data-productsnav="item"].-lvl-1');
        this.images = this.el.querySelectorAll('.js-products-image');
        this.mobileBackButtons = this.el.querySelectorAll('[data-productsnav="back"]');

        // Initialize navigation and sublist toggle
        this.initNavToggle();
        this.initSubListToggle();

        // Initialize image hover if applicable
        if (this.el.querySelector('.js-products-images') !== null) {
            this.initImageHover();
        }
    }

    // Initialize type navigation toggle
    initNavToggle() {
        if (this.productsNavTypes.length > 1) {
            this.productsNavTypes.forEach((item) => {
                item.addEventListener('click', () => this.handleNavToggle(item));
            });
        }
        // Initialize mobile back button functionality
        this.mobileBackButtons.forEach((item) => {
            item.addEventListener('click', () => this.handleMobileBack(item));
        });
    }

    handleNavToggle(item) {
        let newActive = item.dataset.type;

        // Update active types and sublists
        this.toggle(newActive);
        this.clearActiveSubItems();
        this.clearActiveImages();

        // Set the first image for the new active type
        let firstImageSelector = `[data-parentlist="${newActive}"]`;
        let firstImage = this.el.querySelector(firstImageSelector)?.dataset.hover;
        this.setImage(firstImage);
    }

    handleMobileBack(item) {
        let parentlist = item.dataset.parentlist;
        let sublist = item.dataset.sublist;
        let subItems = this.el.querySelectorAll(`[data-parentlist="${parentlist}"][data-sublist="${sublist}"]`);

        if (subItems.length === 0) return;

        // Clear active sublist items
        subItems.forEach((subItem) => subItem.classList.remove('is-active'));
    }

    // Initialize sublist toggle functionality
    initSubListToggle() {
        this.productsNavItems.forEach((item) => {
            item.addEventListener('click', (e) => this.handleSubListToggle(item, e));
        });
    }

    handleSubListToggle(item, event) {
        let parentlist = item.dataset.parentlist;
        let sublist = item.dataset.sublist;
        let subItems = this.el.querySelectorAll(`[data-parentlist="${parentlist}"][data-sublist="${sublist}"]`);

        if (subItems.length === 0) return;
        
        event.preventDefault();
        
        // Toggle active state for clicked item
        subItems.forEach((subItem) => subItem.classList.toggle('is-active'));
        
        // Clear other active sublists
        this.clearActiveSubItems(sublist);
    }

    // Initialize image hover functionality
    initImageHover() {
        this.productsNavItems.forEach((item) => {
            item.addEventListener('mouseenter', () => {
                let imgEl = item.dataset.hover;
                this.setImage(imgEl);
            });
        });
    }

    // Toggle active type
    toggle(type) {
        this.el.dataset.active = type;
    }

    // Set the active image based on the selector
    setImage(imageSelector) {
        this.clearActiveImages();
        let imageEl = this.el.querySelector(imageSelector);
        if (imageEl) {
            imageEl.classList.add('is-active');
        }
    }

    // Clear all active sublist items except optionally keeping the provided sublist
    clearActiveSubItems(sublistToKeep = null) {
        let activeSubItems = this.el.querySelectorAll('[data-sublist].is-active');
        activeSubItems.forEach((activeSubItem) => {
            if (sublistToKeep === null || activeSubItem.dataset.sublist !== sublistToKeep) {
                activeSubItem.classList.remove('is-active');
            }
        });
    }

    // Clear all active images
    clearActiveImages() {
        this.images.forEach((image) => {
            image.classList.remove('is-active');
        });
    }
}
